<template>
  <div>
    <div :class="$vuetify.breakpoint.mobile ? 'mobileBanner banner':'banner'" v-show="carouselList">
      <!-- <v-carousel
        cycle
        hide-delimiter-background
        :hide-delimiters="carouselList.length<=1"
        :show-arrows="false"
        height="100%"
        contain
      >
        <v-carousel-item 
          v-for="(item, i) in carouselList" 
          :key="i"
          :src="lang == 'zh' ? item.picturesZhCn : ( item.picturesEnUs ? item.picturesEnUs : item.picturesZhCn )"
          @click="jumpBanner(item)"
          style="min-height:220px"
        ></v-carousel-item>
      </v-carousel> -->
       <slider ref="slider" :options="{ currentPage: 1 , loop: true, autoplay: 2000 }">
            <slideritem v-for="(item,index) in carouselList" :key="index" class="ZoomIn" >
                <img :src="(lang == 'zh'?item.picturesZhCn: ( item.picturesEnUs ? item.picturesEnUs : item.picturesZhCn ) )" class="imgClass" @click="jumpBanner(item)">
            </slideritem>
        </slider>
    </div>
    
      
    <v-container>
        <v-row class="main-box" v-show="aboutListMain&&aboutListMain.contents&&aboutListMain.contents.length>0">
          <div class="main-header">
            <h1>{{$t('main.aboutUs')}}</h1>
            <span></span>
          </div>
          <div class="about-info">
            <div v-for="(item,index) in aboutListMain.contents" :key="index" class="aboutBox"  @mouseenter="aboutMouseEnter(index)" @mouseleave="aboutMouseLeave(index)" @click="aboutJump(index)">
              <div v-if="aboutImgView && aboutImgViewIndex == index" class="aboutView">
                <img :src="(lang == 'zh' ? (item.picturesZhCn ? item.picturesZhCn.split(',')[1] : ''): (item.picturesEnUs ? item.picturesEnUs.split(',')[1] : ((item.picturesZhCn ? item.picturesZhCn.split(',')[1] : ''))))" >
                <img :src="(lang == 'zh' ? (item.picturesZhCn ? item.picturesZhCn.split(',')[2] : ''): (item.picturesEnUs ? item.picturesEnUs.split(',')[2] : ((item.picturesZhCn ? item.picturesZhCn.split(',')[2] : ''))))" class="viewImg">
              </div>
              <img :src="(lang == 'zh' ? (item.picturesZhCn ? item.picturesZhCn.split(',')[0] : ''): (item.picturesEnUs ? item.picturesEnUs.split(',')[0] : ((item.picturesZhCn ? item.picturesZhCn.split(',')[0] : ''))))" class="aboutImg" v-else>
            </div>
          </div>
        </v-row>
        <v-row :class="$vuetify.breakpoint.mobile ? 'mobileNesBox main-box news-box':'main-box news-box'" v-show="newsList&&newsList.contents&&newsList.contents.length>0">
          <div class="main-header">
            <h1>{{$t('main.news')}}</h1>
            <span></span>
          </div>
            <slider ref="slider" :options="options" class="newsList">
                <slideritem v-for="(item,index) in newsList.contents" :key="index" class="newsItem ZoomIn">
                    <img @click="newsJump(item)" :src="(lang == 'zh'?item.picturesZhCn: ( item.picturesEnUs ? item.picturesEnUs : item.picturesZhCn ) )" style="height:160px,width:200px">
                    <div class="newDetail" style="padding: 5px 10px;" @click="newsJump(item)">
                        <span>{{ lang == 'zh' ? item.contentNameZhCn : ( item.contentNameEnUs ? item.contentNameEnUs : item.contentNameZhCn) }}</span>
                        <p>{{item.contentDate | filterDate}}</p>
                    </div>
                </slideritem>
            </slider>
        </v-row>
        <v-row class="main-box" v-show="ipViewList&&ipViewList.length>0">
          <div class="main-header">
            <h1>{{$t('main.ourIp')}}</h1>
            <span></span>
          </div>
          <div class="ip-info">
            <div v-for="(item,index) in ipViewList" :key="index" :class="!$vuetify.breakpoint.mobile ? 'pcIpBox ZoomIn':'mobileIpBox'" :style=" !( item.picturesZhCn || item.picturesEnUs ) ? 'width:0':''">
              <img :src="lang == 'zh' ? item.picturesZhCn : ( item.picturesEnUs ? item.picturesEnUs : item.picturesZhCn)" @click="jump(item.link)" class="pointer">
            </div>
          </div>
        </v-row>
    </v-container>
    <div class="main-box url-box">
      <div class="main-header url-header">
        <h1>{{$t('main.link')}}</h1>
        <span></span>
      </div>
      <div :class="$vuetify.breakpoint.mobile ? 'murl-info url-info':'url-info'">
        <div v-for="(item,index) in linkDataList" :key="index"  v-if="lang == 'zh' ? (item.picturesZhCn) : (item.picturesEnUs)">
            <!-- <a :href="'http://'+item.externalLink" target="_blank" :class="$vuetify.breakpoint.mobile? 'mobileUrl':''">{{lang == 'zh' ? item.contentNameZhCn : ( item.contentNameEnUs ? item.contentNameEnUs : item.contentNameZhCn)}}</a> -->
            <img :src="lang == 'zh' ? item.picturesZhCn : item.picturesEnUs" @click="jumpBanner(item)">
        </div>
      </div>
    </div>
    <div :class="$vuetify.breakpoint.mobile ? 'contactMobileBox main-box contact-box':'main-box contact-box'" id="contact" :style="{ 'background-image': lang == 'zh' ? 'url('+contactBox.picturesZhCn+')' : 'url('+contactBox.picturesEnUs+')' }">
      <div class="main-header contact-header">
        <h1>{{$t('main.contactUs')}}</h1>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
  import mainApi from '../api/index'
  import newApi from '../api/news'
  import ipApi from '../api/ip'
  import { slider, slideritem } from 'vue-concise-slider'
  export default {
    name: 'main',
    components:{slider,slideritem},
    data: () => ({
      options: {
          // currentPage: 0,
          // tracking: false,
          thresholdDistance: 100,
          thresholdTime: 300,
          // infinite: 4,
          // slidesToScroll: 4,
          // loop: false,
          // itemAnimation: true
      },
      carouselList:[],
      pageData: [],
      //关于我们的图片
      aboutListMain:[],
      ipViewList:[],
      aboutImgView:false,
      aboutImgViewIndex:'',
      //新闻资讯
      newsList:[],
      //我们的ip
      ipDataList:[],
      //友情链接的文字
      linkDataList:[],
      urlView: false,
      urlViewIndex:'',
      carouselNewsIndex:'',
      contactBox:'',

    }),
    filters:{
      filterDate(item){
        return item?.substring(0,item?.indexOf('00')-1)
      }
    },
    computed:{
      lang(){
        return this.$i18n.locale;
      }
    },
    watch:{
      '$route.query.contact'(val){
        this.$nextTick(()=>{
          document.querySelector("#contact").scrollIntoView(true);
        })
      }
    },
    methods:{
      jumpBanner(item){
        if( item.externalLink == null ) return
        var u = navigator.userAgent;
        var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if(isiOS) {
          window.location.href = (item.externalLink.includes('http:') || item.externalLink.includes('https:')) ? item.externalLink :'http://'+item.externalLink;
        }else{  
          if( item.externalLink.includes('http:') || item.externalLink.includes('https:') ) window.open(item.externalLink,"_blank");
            else window.open('http://'+item.externalLink,"_blank");
        }
      },
        //关于我们的鼠标事件
        aboutMouseEnter(index){
          this.aboutImgView = true;
          this.aboutImgViewIndex = index;
        },
        aboutMouseLeave(index){
          this.aboutImgView = false;
          this.aboutImgViewIndex = '';
        },
        //关于我们的四个跳转
        aboutJump(index){
          let jumpList = [
            '/about',//关于我们
            '/vocationalWork',//业务范围
            '/market',//业务市场
            '/channels?sectionCode=ac_channels_popup_shop',//零售渠道
          ]
          this.$router.push(jumpList[index])
        },
        //新闻跳转
        newsJump(item){
          if( item.externalLink ) window.open(item.externalLink,'_blank')
            else this.$router.push({ path: '/newsDetail', query: { id: item.contentId }})
        },
        //友情链接的鼠标事件
        urlMouseEnter(index){
          this.urlView = true;
          this.urlViewIndex = index;
        },
        urlMouseLeave(index){
          this.urlView = false;
          this.urlViewIndex = '';
        },
        async getData(){
          //获取轮播 
          let { data: bannerListData } = await mainApi.getBannerList();
          this.carouselList = bannerListData[0].contents || [];
          // 获取banner
          // let { data: bannerData } = await mainApi.getBanner();
          // this.carouselList = bannerData;
          //获取关于我们
          let { data:aboutMain } = await mainApi.getAboutData();
          this.aboutListMain = aboutMain[0];
          //获取新闻资讯
          let { data: newsData } = await newApi.getNewsList();
          this.newsList = newsData[0];
          this.newsList.contents = newsData[0].contents.sort((a, b) => a.sortIndex - b.sortIndex);
          console.log(this.newsList,'this.newsList')
          let { data: ipData } = await ipApi.getIpList();
          this.ipDataList = ipData[0].children;
          ipData[0].children.forEach(item=>{
            if( item.children ){
              item.children.forEach(val=>{
                if(val.sectionType == 'ip_main_img'){
                  console.log(val.contents,'val.contents.')
                  this.ipViewList.push({ 
                    picturesZhCn: val.contents?.length>0 ? val.contents[0]?.picturesZhCn : '' ,
                    picturesEnUs: val.contents?.length>0 ? val.contents[0]?.picturesEnUs : '' ,
                    link: val.contents[0]?.externalLink
                  })
                }
              })
              
            }
          })
          //友情链接
          let { data: linkData } = await mainApi.getLink();
          this.linkDataList = linkData[0].contents;
          //联系我们
          let { data: contactData } = await mainApi.getContact();
          this.contactBox = contactData;
       },
        newsCarouselChange(e){
          this.carouselNewsIndex = e;
        },
        jump(link){
          window.location.href = link;
        }
    },
    async mounted(){
      await this.getData();
      if( window.location.search !== '' ) {
        setTimeout(() => {
          document.querySelector("#contact").scrollIntoView(true);
        }, 1000);
      }
    },
  }
</script>
<style lang="scss" scoped>

.pointer{
  cursor: pointer;
}
.mobileBanner{
  height: auto!important;
}
.banner{
  height: 100vh;
  width: 100vw;
  // z-index: 9999;
  // position: relative;
  ::v-deep .v-btn{
    transform: scale(0.5)!important;
    opacity: 1!important;
    z-index: 998!important;
  }
  ::v-deep .v-btn::before{
    transform: scale(0.6)!important;
    opacity: 1!important;
  }
  ::v-deep .v-btn--active::before{
    opacity: 1!important;
    color: red;
    z-index: 999!important;
  }
  ::v-deep .v-image__image{
    background-size: 100%;
  }
}

.main-box{
  width: 80%;
  margin-left: 10%;
  .main-header{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    margin-top: 20px;
    span{
      width: 50px;
      height: 3px;
      background: red;
    }
  }
}
.mobileNesBox{
  height: 100%;
  min-height: 60rem!important;
}
 .imgClass{
      object-fit: fill;
      height: 100%;
      width: 100vw;
  }
.news-box{
  position: relative;
  margin-top: 10px;
  height: 100%;
  min-height: 420px;
  overflow: hidden;
  ::v-deep .v-image__image--cover{
    background-size: 100%!important;
  }
  .mobileNewsSlot{
    font-size: 2rem;
    padding: 10px 0;
    h3{
      // overflow: hidden;
      // white-space: nowrap;
      // text-overflow: ellipsis;
      // -o-text-ovoverflow: ellipsis;
    }
    div{
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    
  }
 
  ::v-deep.slider-container{
    white-space: pre-wrap!important;
  }
  .newsList{
        min-height: 400px;
        display: flex;
        justify-content: flex-start;
        margin-right: 10px;
        .newsItem{
          cursor: pointer;
            height: 360px;
            overflow: hidden;
            // width: 24%;
            width: 224px;
            background: #fff;
            border-radius: 2px;
            display: flex;
            flex-direction: column;
            color: #000;
            font-size: 14px;
            margin-right: 10px;
            white-space: pre-wrap;
            border: 1px solid #f8f8f8;
            box-shadow: 1px 1px #f8f8f8;
            img{
                height: 220px;
                width: 220px;
                object-fit:cover;
            }
            .newDetail{
                height: 150px;
                width: 92%;
                text-align: start;
                position: relative;
                p{
                    position: absolute;
                    left: 5%;
                    bottom: 5%;
                }
            }
        }
    }
  @media screen and (max-width: 540px) {
    .newsItem{
      width: 76vw!important;
      margin-left: 13vw;
      img{
        height: 76vw!important;
        width: 76vw!important;
      }
    }
  }
  .carousel-slot{
    position: absolute;
    height: 100%;
    right: 0;
    width: 100%;
    background: url('../assets/images/main/news-bg.png');
    background-size: 100%;
    padding: 20px 10px;
    padding-left: 60%;
    div{
      margin-top: 20px;
    }
    span{
      color: red;
      display: flex;
      align-items: center;
      margin-top: 20px;
      ::v-deep .v-icon{
        font-size: 22px!important;
        transform: rotateX(45deg);
      }
    }
  }
  .newsRichText{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 9;
    overflow: hidden;
  }
  .footerCircle{
    height: 30px;
    position: absolute;
    right: 20px;
    bottom: 10px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .circle{
      width: 7px;
      height: 7px;
      margin-right: 3px;
      border-radius: 50%;
      background: #fff;
    }
    .newActive{
      border-radius: 30px;
      width: 20px;
      background: red;
      margin-top: 2px;
    }
  }
}

.about-info{
    display: flex;
    justify-content: space-around;
    width: 100%;
    flex-wrap: wrap;
    .aboutImg{
        width: 100%;
        // border-radius: 200px;
    }
    .aboutBox{
      position: relative;
      width: 20%;
      cursor: pointer;
      .aboutView{
        position: absolute;
        left: 0;
        // transform: scale(1.05);
        // transform: translateY(-1.05%);
        img{
          width: 100%;
          object-fit: scale-down;
        }
        .viewImg{
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
        }
      }
    }
}
.ip-info{
    width: 100%;
    .pcIpBox{
      float: left;
      width: 25%;
      img{
        width: 98%;
        border-radius: 2%;
        margin: 2%;
        margin-top: -2.9%;
        object-fit: fill;
      }
    }
    .mobileIpBox{
      float: left;
      width: 50%;
      img{
        width: 97%;
        border-radius: 2%;
        margin: 2%;
        object-fit: fill;
      }
    }
}
.url-box{
    // background: #e7291a;
    margin-top: 40px;
    width: 100%;
    margin-left: 0;
    height: 100%;
    .url-info{
        height: 100%;
        margin: auto 5% ;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding-bottom: 20px;
        div{
          flex: 1;
          margin: 0 5px 5px 0;
          width: calc(95% / 8);
          min-width: calc(95% / 8); 
          max-width: calc(95% / 8);
          height: 100%;
          display: flex;
          justify-content: center;
          cursor: pointer;
          img{
            width: 100%;
            height: 100%;
            max-width: 20rem;
            border-radius: 2%;
          }
          &:nth-child(8n) { // 去除第3n个的margin-right
            margin-right: 0;
          }
      }
    }
    .murl-info{
      div{
        width: calc(95% / 4)!important;
        min-width: calc(95% / 4)!important; 
        max-width: calc(95% / 4)!important;
      }
    }
}
.mobileUrl{
  font-size: 2rem;
}
.contactMobileBox{
  background-size: 100%!important;
}
.contact-box{
  width: 100%;
  height: 100%;
  margin: 0;
  min-height: 33rem;
  // color: #fff;
  background: url('../assets/images/default-img.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
@media screen and (max-width: 540px){
    .contact-box{
        min-height: 17rem;
    }
  }

.ZoomIn{
  cursor: pointer;
  transition: all .3s ease-in 0s;
}
.ZoomIn:hover{
  transform: scale(1.01);
  transition: all 0.3s ease-in;
}
</style>
